import { lazy } from "react";
const AuthorityLogDetail = lazy(() => import("@/pages/report-authority-details/authority-log/AuthorityLog"));
const AuthorityRoleDetail = lazy(() => import("@/pages/report-authority-details/authority-role/AuthorityRole"));
const ChildSystemLog = lazy(() => import("@/pages/report-authority-details/child-system-log/ChildSystemLog"));
const reportAuthorityRoute = [
  {
    path: "/authorityLog",
    name: "日志操作明细",
    component: AuthorityLogDetail,
    menuUrl: "/authorityLog"
  },
  {
    path: "/authorityRole",
    name: "角色权限明细",
    component: AuthorityRoleDetail,
    menuUrl: "/authorityRole"
  },
  {
    path: "/childSystemLog",
    name: "子系统日志明细",
    component: ChildSystemLog,
    menuUrl: "/childSystemLog"
  }
];
export default reportAuthorityRoute;